export const environment = {
  production: false,
  api_url: 'https://dev-apiv5.menu2order.com/api',//'http://localhost:53941/api',
  map_key: 'AIzaSyBvFKdQpffXNAm-TrePUaFSejuwphCvjW8',
  clients: 'https://appkudos.blob.core.windows.net/dev/client/clients.json',
};
